import { NOT_OPEN_YET, NOT_OPEN_YET_NOTICE } from '~/deck2/opening';
import { cn } from '~/lib/utils';
import brand from '../brand.module.css';
import styles from './OpeningNotice.module.css';

/** True for the server's "Deck isn't open for new accounts yet" answer, which gets this notice rather than an error. */
export const isNotOpenYet = (message: string | null | undefined) => message === NOT_OPEN_YET;

/** Someone with no account, before Deck opens: when it opens, and the way in, in place of an error. */
export const OpeningNotice = () => (
  <div className={styles.notice} role="status">
    <p className={styles.title}>{NOT_OPEN_YET_NOTICE.title}</p>
    <p className={styles.body}>{NOT_OPEN_YET_NOTICE.body}</p>
    <a className={cn(brand.button, brand.ink, styles.action)} href={NOT_OPEN_YET_NOTICE.href}>
      {NOT_OPEN_YET_NOTICE.action}
      <svg width="16" height="14" viewBox="0 0 16 14" aria-hidden>
        <path d="M1 7H14M9 2L14 7L9 12" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </a>
  </div>
);
